export const navigationsList: NavigationItem[] = [
    {
        title: "common.category-casino",
        nav: [
            {
                name: "common.category-popular",
                url: "/game-categories/popular",
            },
            {
                name: "common.category-provably-fair",
                url: "/game-categories/provably-fair",
            },
            {
                name: "common.category-new",
                url: "/game-categories/new",
            },
            {
                name: "common.category-slots",
                url: "/game-categories/slots",
            },
            {
                name: "common.category-table-games",
                url: "/game-categories/table-games",
            },
            {
                name: "common.category-jackpot",
                url: "/game-categories/jackpot",
            },
        ],
    },
    {
        title: "common.category-live-casino",
        nav: [
            {
                name: "common.category-roulette",
                url: "/game-categories/roulette",
            },
            {
                name: "common.category-blackjack",
                url: "/game-categories/blackjack",
            },
            {
                name: "common.category-baccarat",
                url: "/game-categories/baccarat",
            },
            {
                name: "common.category-poker",
                url: "/game-categories/poker",
            },
        ],
    },
    {
        title: "common.features",
        nav: [
            {
                name: "common.category-promotions",
                url: "/promotions",
            },
            {
                name: "common.category-vip",
                url: "/vip",
            },
            {
                name: "popup.lucky-win-title",
                alias: "lucky-wheel",
            },
            {
                name: "common.category-tournaments",
                url: "/tournaments",
            },
            {
                name: "common.achievements",
                url: "/achievements",
            },
            {
                name: "common.affiliate-program",
                external: true,
                url: "https://admin.leadboost.partners/partner/register",
            },
        ],
    },
    {
        title: "common.about-us",
        nav: [
            {
                name: "common.kyc-aml-policy",
                url: "/info/KYC-Policies-Privacy-Management-of-Personal-Data",
            },
            {
                name: "common.deposit-limits",
                url: "/info/deposit-limits",
            },
            {
                name: "common.payments",
                url: "/info/payments",
            },
            {
                name: "common.terms-conditions",
                url: "/info/terms-and-conditions",
            },
            {
                name: "common.privacy-policy",
                url: "/info/privacy-policy",
            },
            {
                name: "common.cookies-policy",
                url: "/info/cookies-policy",
            },
        ],
    },
    {
        title: "common.help",
        nav: [
            {
                name: "common.faq",
                url: "/info/faq",
            },
            {
                name: "common.guide",
                url: "/info/guide",
            },
        ],
    },
];

interface NavigationItem {
    title: string;
    nav: NavigationLink[],
}

interface NavigationLink {
    name: string;
    url?: string;
    alias?: string;
    external?: boolean;
}
